export default "__VITE_ASSET__dX$f88C2__"